import base from "./base";
import { addErrorNotification } from "../utils/notifications";

export const getCaptcha = () =>
	base.get("/auth/recaptcha").then(res => res.data);



// WEBPACK FOOTER //
// ./src/services/captcha.js